import { Box, Card, CardContent, Chip, CircularProgress, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { fmtDate, statusColor } from "../../../format";
import type { MaintenanceAlert } from "../../../types";

interface AlertsCardProps {
  loading: boolean;
  alerts: MaintenanceAlert[];
}

export function AlertsCard({ loading, alerts }: AlertsCardProps) {
  return (
    <Card variant="outlined">
      <CardContent>
        <Typography variant="h6" gutterBottom>Active Heartbeat/Fault Alerts</Typography>
        {loading && (
          <Box sx={{ display: "flex", justifyContent: "center", my: 2 }}>
            <CircularProgress size={24} />
          </Box>
        )}
        {!loading && alerts.length === 0 && (
          <Typography variant="body2" color="text.secondary">
            No active alerts.
          </Typography>
        )}
        {!loading && alerts.length > 0 && (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Charge Point</TableCell>
                <TableCell>Alert</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Connection</TableCell>
                <TableCell>Last Heartbeat</TableCell>
                <TableCell>Active Since</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {alerts.map((alert) => (
                <TableRow key={`${alert.charge_point_id}-${alert.alert_type}`}>
                  <TableCell sx={{ fontFamily: "monospace" }}>{alert.charge_point_id}</TableCell>
                  <TableCell>
                    <Chip
                      label={alert.alert_type === "heartbeat_missing" ? "Heartbeat Missing" : "Faulted"}
                      color={alert.alert_type === "heartbeat_missing" ? "warning" : "error"}
                      size="small"
                    />
                  </TableCell>
                  <TableCell>
                    <Chip label={alert.status} color={statusColor(alert.status)} size="small" />
                  </TableCell>
                  <TableCell>{alert.is_connected ? "Connected" : "Offline"}</TableCell>
                  <TableCell>{fmtDate(alert.last_heartbeat)}</TableCell>
                  <TableCell>{fmtDate(alert.active_since)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
}
